<front-photosphere [isBack]="false" [nurseryUUID]="nurseryUUID" [sphereUUID]="startUUID"></front-photosphere>
